/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_On_AirInputs */

const th_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังถ่ายทอดสด`)
};

const en_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Broadcasting`)
};

const ja_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信中`)
};

const zh_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const es_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retransmitiendo`)
};

const pt_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transmitindo`)
};

const id_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengudara`)
};

const fr_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diffusion`)
};

const tl_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasa ere`)
};

const vi_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang lên sóng`)
};

const ko_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방송 중`)
};

const de_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überträgt`)
};

const ru_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В эфире`)
};

const tr_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayında`)
};

const it_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In onda`)
};

const pl_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na antenie`)
};

const uk_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ефірі`)
};

const hi_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारण में`)
};

const ar_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`على الهواء`)
};

const ms_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di udara`)
};

const bn_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্প্রচারে`)
};

const zh_tw2_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播中`)
};

const zh_hk2_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轉播中`)
};

const ur_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نشریات جاری`)
};

const fa_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روی آنتن`)
};

const sw_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hewani`)
};

const nl_video_on_air = /** @type {(inputs: Video_On_AirInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In de lucht`)
};

/**
* | output |
* | --- |
* | "Broadcasting" |
*
* @param {Video_On_AirInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_on_air = /** @type {((inputs?: Video_On_AirInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_On_AirInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_on_air(inputs)
	if (locale === "ja") return ja_video_on_air(inputs)
	if (locale === "zh") return zh_video_on_air(inputs)
	if (locale === "es") return es_video_on_air(inputs)
	if (locale === "pt") return pt_video_on_air(inputs)
	if (locale === "id") return id_video_on_air(inputs)
	if (locale === "fr") return fr_video_on_air(inputs)
	if (locale === "tl") return tl_video_on_air(inputs)
	if (locale === "vi") return vi_video_on_air(inputs)
	if (locale === "ko") return ko_video_on_air(inputs)
	if (locale === "de") return de_video_on_air(inputs)
	if (locale === "ru") return ru_video_on_air(inputs)
	if (locale === "tr") return tr_video_on_air(inputs)
	if (locale === "it") return it_video_on_air(inputs)
	if (locale === "pl") return pl_video_on_air(inputs)
	if (locale === "uk") return uk_video_on_air(inputs)
	if (locale === "hi") return hi_video_on_air(inputs)
	if (locale === "ar") return ar_video_on_air(inputs)
	if (locale === "ms") return ms_video_on_air(inputs)
	if (locale === "bn") return bn_video_on_air(inputs)
	if (locale === "zh-TW") return zh_tw2_video_on_air(inputs)
	if (locale === "zh-HK") return zh_hk2_video_on_air(inputs)
	if (locale === "ur") return ur_video_on_air(inputs)
	if (locale === "fa") return fa_video_on_air(inputs)
	if (locale === "sw") return sw_video_on_air(inputs)
	if (locale === "nl") return nl_video_on_air(inputs)
	return en_video_on_air(inputs)
});